<template>
    <q-list no-border>
        <q-list-header class="q-pr-lg text-center q-my-xs">
            <router-link to="/"><img src="../../img/identity/logo-unitel-purple.svg" width="60%"/></router-link>
        </q-list-header>

        <q-item v-for="menu in menus" :key="menu.name"
                v-ripple link item exact class="big" :to="'/contents/'+menu.slug">
            {{ $T(menu.name) }}
        </q-item>

        <q-item-separator/>

        <q-item item>
            <div class="row full-width items-baseline">
                <div class="col">
                    <q-input v-model="query" :placeholder="$T('search')"
                             @keydown.enter.prevent="search"/>
                </div>
                <div class="col-auto">
                    <q-btn icon="search" color="primary" class="super-hover on-right"
                           @click.prevent="search"/>
                </div>
            </div>
        </q-item>

        <q-item-separator/>
        <q-item link :to="{name: 'contact'}">{{ $T('contact us') }}</q-item>
        <q-item link :to="{name: 'tec'}">{{ $T('terms ans conditions') }}</q-item>

        <div class="version">
            <small>© Unitel Entrada - V{{ getVersion() }}</small>
        </div>

    </q-list>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { loadMessages } from '../plugins/i18n'

    import {
        QList,
        QListHeader,
        QItem,
        QItemSeparator,
        QBtn,
        QInput,
    } from 'quasar-framework'

    export default {
        components: {
            QList,
            QListHeader,
            QItem,
            QItemSeparator,
            QBtn,
            QInput,
        },

        data() {
            return {
                logo: `${config.appUrl}${config.devAssetsFolder}/img/p4f.svg`,
                query: '',
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                locale: 'lang/locale',
                locales: 'lang/locales',
                menus: 'categories/user_categories'
            }),
        },

        methods: {
            getVersion() {
                return `${config.appVersion}`
            },
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push({ name: 'home' })
            },

            setLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)

                    this.$store.dispatch('lang/setLocale', { locale })
                }
            },

            search() {
                let  term = this.query;
                this.query = null
                this.$router.push({ name: 'contents.search', params: { query: term } })
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue